module.exports = __webpack_public_path__ + "img/product-features.3f6d1eed.svg";